import { DocumentDownloadIcon } from '@heroicons/react/outline';
import { isArray } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';

export function Documents({ documents }: { documents: { url: string }[] }) {
  const { t } = useTranslation();
  return (
    <div className='mt-4 pb-4 md:space-x-0'>
      {isArray(documents) && documents.length > 0 && (
        <h3 className='title pt-4'>{t('common:Documents')}</h3>
      )}
      {documents.map((doc, key) => (
        <a
          className='inline-flex items-center rounded bg-gray-300 px-4 py-2 font-bold text-gray-800 hover:bg-gray-400'
          key={doc.url}
          href={doc.url}
          target='_blank'
          download
          rel='noreferrer'
        >
          <DocumentDownloadIcon className='h-8' />
          <span>Download {key != 0 ? key + 1 : ''}</span>
        </a>
      ))}
    </div>
  );
}
